export default [
    {
        path: '/feed/:network?',
        name: 'Feed List Add Network Connection',
        component: () => import('@/views/feed/FeedList.vue'),
        props: true,
        meta: {
            layout: 'Default',
            abilities: [['manage', 'feeds']]
        },
    },
]
